module.exports = __webpack_public_path__ + "img/example1.9c49fc89.png";